import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: l, useRem: n, color: c, withColor: o, removeClassName: t, disableSSR: p, style: i, ...m }) => {
  const v = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: p }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-chanpin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-äº§å"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? r(c, 0, "#262933") : "#262933",
        datafollowfill: o ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M6.614 8.679a.8.8 0 0 1 1.097-.275l4.23 2.538 4.228-2.538a.8.8 0 0 1 .823 1.372l-4.252 2.552v4.653a.8.8 0 1 1-1.6 0v-4.653L6.888 9.776a.8.8 0 0 1-.274-1.097Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M13.215 2.305a3.05 3.05 0 0 0-2.995.03L4 5.927a3.05 3.05 0 0 0-1.525 2.642v6.899a3.05 3.05 0 0 0 1.58 2.673l6.412 3.526a3.05 3.05 0 0 0 2.94 0l6.496-3.572A2.89 2.89 0 0 0 21.4 15.56V8.774a3.05 3.05 0 0 0-1.51-2.633l-4.672-2.734-.018-.01-1.985-1.092ZM11.02 3.722c.44-.254.98-.26 1.424-.015l1.975 1.086 4.663 2.728c.444.26.718.737.718 1.253v6.788c0 .47-.256.903-.669 1.13l-6.495 3.572a1.45 1.45 0 0 1-1.398 0l-6.412-3.526a1.45 1.45 0 0 1-.751-1.271v-6.9c0-.518.276-.997.725-1.256l6.22-3.59Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
